import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload.js'

const resourceName = 'anexos'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=anexo.dataEnvio,desc`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=anexo.dataEnvio,desc`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClientUpload.post(`${APICore}/${resourceName}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}&page=${index}&size=${limit}&sort=anexo.dataEnvio,desc`, config)
const GetAttachmentShareById = (id, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/anexo/share`, config)

const AttachmentRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Delete,
  Search,
  GetAttachmentShareById
}

export default AttachmentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/attachment.js